module.exports = __webpack_public_path__ + "img/04.ac50ae31.png";